import { render } from "./contact.vue?vue&type=template&id=c2d25b18"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__